<script setup>
import AboutCoin from "@/components/AboutCoin.vue";
import Withdraw from "@/components/Withdraw.vue";
import AddressEdit from "@/components/AddressEdit.vue";
import WithdrawDetail from "@/components/WithdrawDetail.vue";
import DividendsCard from "@/components/DividendsCard.vue";
import { useConfigStore } from "@/store/config";
import { useUserStore } from "@/store/user.js";
import { useTonConnectStore } from "@/store/tonConnect"
import { computed, ref, inject, onMounted, onUnmounted, watch } from "vue";
import {
  appHapticFeedback,
  addCommasToNumber,
  truncateString,
  toastSuccess,
  toastFail,
  formatTimestamp,
  DecimalUtils,
} from "@/utils/common";
import emitter from "@/utils/bus";

import { useI18n } from "vue-i18n";
import TonWeb from "tonweb";
const addressUtils = TonWeb.utils.Address;
const { t } = useI18n();
const tonConnectUI = ref(null); // TON 对象
const $swal = inject("$swal");
const userStore = useUserStore();
const config = useConfigStore();
const tonConnectStore = useTonConnectStore();
let isTon = config.withdraw_chain.toLowerCase().includes("ton");
const isList = ref(false);
// let isList = ref(false);
// watch(tonConnectStore.TonConnect.connected, (newVal) => {
//   isList.value = newVal && userStore.ton_address;
// }, { immediate: true });
const isListFunc = () => {
  isList.value = tonConnectStore.TonConnect.connected && userStore.ton_address;
}
const points = computed(() => {
  return addCommasToNumber(userStore.points);
});
const balance = computed(() => {
  return addCommasToNumber(userStore.balance);
});
const address = computed(() => userStore.ton_address)
const tonAddress = computed(() => {
  try {
    const addressRaw = new addressUtils(address.value);
    const walletAddress = addressRaw.toString(true);
    return walletAddress;
  } catch (error) {
    return "";
  }
})

const formattedAddress = computed(() => {
  if (!userStore.ton_address) return "";
  const address = userStore.ton_address;
  if (address.length <= 10) return address;
  return address.slice(0, 4) + "*****" + address.slice(-4);
});

console.log(tonAddress.value);

const handleDisconnect = async () => {
  if (isList.value) {
    tonConnectStore.TonConnect.disconnect();
    userStore.ton_address = "";
    isListFunc();
  }

}
const withdraw_address = computed(() => {
  return tonAddress.value;
});
const withdraw_record = computed(() => {
  return userStore.withdraw_record;
});
const web_withdraw_record = computed(() => {
  return userStore.web_withdraw_record;
});
const withdrawShow = ref(false);
const addressShow = ref(false);
const balanceAmountRef = ref(null);

const rowDetail = ref({});

// 新增弹窗控制
const isVisible = ref(false);

onMounted(() => {
  isListFunc();
  emitter.on("showWalletModal", (res) => {
    isVisible.value = res;
  });
  emitter.on("hideWalletModal", () => {
    isVisible.value = false;
  });

});

onUnmounted(() => {
  emitter.off("showWalletModal");
  emitter.off("hideWalletModal");
});

const handleClose = () => {
  isVisible.value = false;
  appHapticFeedback();
  emitter.emit("hideWalletModal");
};

const showAboutCoin = () => {
  appHapticFeedback();
  emitter.emit("showAboutCoin", true);
};

const handleWithdrawOnShow = () => {
  appHapticFeedback();
  isTon = config.withdraw_chain.toLowerCase().includes("ton");
  if (withdraw_address.value == "" || withdraw_address.value == null) {
    if (isTon) {
      tonConnectStore.linkedWallet(true);
    } else {
      addressShow.value = true;
    }
    return;
  }
  withdrawShow.value = true;
};

const handleWithdrawOnHide = () => {
  withdrawShow.value = false;
};

const handleAddressOnShow = () => {
  appHapticFeedback();
  isTon = config.withdraw_chain.toLowerCase().includes("ton");
  if (!isTon) {
    addressShow.value = true;
  } else {
    tonConnectStore.linkedWallet(true);
  }
};
const handleAddressOnHide = () => {
  addressShow.value = false;
};

const copyAddress = async () => {
  appHapticFeedback();
  try {
    await navigator.clipboard.writeText(withdraw_address.value);
    toastSuccess($swal, t("message.copySuccess"));
  } catch (error) {
    toastFail($swal, t("message.copyFailure"));
  }
};

const recordDetailOnClick = (item, isWeb) => {
  appHapticFeedback();
  rowDetail.value = item;
  emitter.emit("showWithdrawDetail", true);
};
const toConnectWallet = async () => {
  appHapticFeedback();
  let res = await tonConnectStore.linkedWallet(true);
  if (res) {
    isListFunc();
    toastSuccess($swal, t("message.connectSuccess"));
  } else {
    toastFail($swal, t("message.connectFailure"));
  }
}
</script>

<template>
  <div class="modal-wrapper" v-if="isVisible">
    <div class="modal-overlay"></div>
    <div class="modal-container">
      <div class="modal-header">
        <div class="title">{{ $t("message.WalletBalance") }}</div>
        <div class="close-btn" @click="handleClose">×</div>
      </div>
      <!-- 原始内容开始 -->
      <div>
        <AboutCoin />
        <Withdraw :show="withdrawShow" @close="handleWithdrawOnHide" />
        <AddressEdit :show="addressShow" @close="handleAddressOnHide" />
        <WithdrawDetail :detail="rowDetail" />

        <div class="itemBox">
          <div class="balance-box">
            <!-- TAI 卡片 -->
            <div class="coin-card">
              <img class="icon" :src="config.coin_image" alt="" />
              <div class="coin-info">
                <div class="coin-name">TAI</div>
                <div class="coin-balance">{{ points }}</div>
              </div>
              <div class="coin-action">
                <span class="about-link" @click="showAboutCoin">{{ $t("message.AboutTAI") }}</span>
              </div>
            </div>
            <!-- TON 卡片 -->
            <div class="coin-card">
              <img class="icon" :src="config.ton_coin_image || config.coin_image" alt="" />
              <div class="coin-info">
                <div class="coin-name">{{ config.coin_name || "TON" }}</div>
                <div ref="balanceAmountRef" class="coin-balance">{{ balance }}</div>
              </div>
              <div class="coin-action">
                <button class="withdraw-btn" @click="handleWithdrawOnShow">{{ $t("message.Withdraw") }}</button>
              </div>
            </div>
          </div>
        </div>

        <div class="itemBox">
          <DividendsCard :balance-target="balanceAmountRef" />
        </div>

        <div class="itemBox">
          <div class="title">{{ $t("message.Connectwallet") }}</div>
          <div class="addressBox">
            <template v-if="!isList">
              <div class="address-title not-connected">{{ $t("message.Notconnected") }}</div>
              <button class="wallet-btn" @click="toConnectWallet">
                <img src="@/assets/icon/wallet.svg" class="wallet-icon" />
                {{ $t("message.Connectwallet") }}
              </button>
            </template>
            <template v-else>
              <div class="address-title connected">{{ formattedAddress }}</div>
              <button class="wallet-btn" @click="handleDisconnect">
                <img src="@/assets/icon/disconnect.svg" class="wallet-icon" />
                {{ $t("message.Disconnect") }}
              </button>
            </template>
          </div>
        </div>

        <div class="itemBox">
          <div class="title">{{ $t("message.WithdrawalRecord") }}</div>
          <div class="withdrawBox">
            <div class="empty-list" v-if="web_withdraw_record.length == 0">
              {{ $t("message.Norecords") }}
            </div>
            <div class="record-list" v-else>
              <div class="record-item" v-for="(item, index) in web_withdraw_record" :key="index"
                @click="recordDetailOnClick(item, true)">
                <div>
                  <div class="record-amount">
                    {{ addCommasToNumber(item.send_amount) }} {{ config.coin_name }}
                  </div>
                  <div class="record-time">{{ formatTimestamp(item.created_at) }}</div>
                </div>
                <div>
                  <div class="record-status" v-if="item.audit_status == 1">
                    {{ $t("message.Processing") }}
                  </div>
                  <div class="record-status" v-if="item.audit_status == 2">
                    {{ $t("message.Success") }}
                  </div>
                  <div class="record-status" v-if="item.audit_status == 3">
                    {{ $t("message.Rejection") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 原始内容结束 -->
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/surfaces" as surface;

// 新增的弹窗样式
.modal-wrapper {
  @include surface.dialog-overlay;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
}

.modal-container {
  @include surface.dialog-panel;
  position: relative;
  background-color: #1e1e1e;
  border: 1px solid #2d2d2d;
}

.modal-header {
  @include surface.dialog-header;
  margin-bottom: 6px;
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
  }

  .close-btn {
    @include surface.close-button;
    color: #ffffff;
    font-weight: bold;
  }
}

.itemBox {
  margin-bottom: 8px;

  .title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 6px;
    color: #ffffff;
    margin-top: 12px;
  }
}

.balance-box {
  gap: 6px;
  display: flex;
  flex-direction: column;
  background: none;
  padding: 0;

  .coin-card {
    @include surface.card;
    display: flex;
    align-items: center;
    background: black;
    margin-bottom: 0;
    justify-content: space-between;

    .icon {
      width: 36px;
      height: 36px;
      margin-right: 6px;
      border-radius: 50%;
      background: #333;
    }

    .coin-info {
      min-width: 0;
      margin-left: 0;
      flex: 1;
      display: flex;
      flex-direction: column;

      .coin-name {
        font-size: 13px;
        color: #a0a0a0;
      }

      .coin-balance {
        font-size: 20px;
        line-height: 1.4;
        overflow-wrap: anywhere;
        color: #fff;
        font-weight: bold;
      }
    }

    .coin-action {
      display: flex;
      align-items: center;

      .about-link {
        @include surface.press-feedback;
        font-size: 13px;
        color: #a0a0a0;
        cursor: pointer;
      }

      .withdraw-btn {
        @include surface.button;
        background: #8f96ff;
        color: #fff;
        border: none;
        cursor: pointer;
      }
    }
  }
}

.addressBox {
  padding: 8px;
  border-radius: 12px;
  background: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0;
  box-shadow: none;

  .address-title {
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 8px;
    text-align: center;

    &.not-connected {
      color: #a0a0a0;
      font-weight: 500;
    }

    &.connected {
      color: #fff;
      font-weight: bold;
      letter-spacing: 0.5vw;
    }
  }

  .wallet-btn {
    @include surface.button;
    width: 100%;
    background: #8f96ff;
    color: #fff;
    border: none;
    font-weight: bold;
    cursor: pointer;
    margin-top: 0;
    box-shadow: none;

    .wallet-icon {
      width: 4vw;
      height: 4vw;
      margin-right: 2vw;
      display: inline-block;
    }
  }
}

.withdrawBox {
  border-radius: 12px;
  font-size: 14px;
  background-color: #2d2d2d;
  overflow: hidden;

  .empty-list {
    padding: 12px 8px;
    text-align: center;
    color: #a0a0a0;
  }

  .record-list {
    .record-item {
      @include surface.press-feedback;
      padding: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #1e1e1e;

      &:last-child {
        border-bottom: none;
      }

      .record-amount {
        font-size: 14px;
        color: #ffffff;
        margin-bottom: 1vw;
      }

      .record-time {
        font-size: 12px;
        color: #a0a0a0;
      }

      .record-status {
        font-size: 12px;
        color: v-bind("config.themes_color");
      }
    }
  }
}
</style>
